import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
import { onBeforeRouteUpdate, useRoute } from 'vue-router';
import { ElConfigProvider } from 'element-plus';
import { init } from '@/preset';
import Default from './container/Default';
import Auth from './container/Auth';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
const __default__ = {
  components: {
    Default,
    Auth
  }
};
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const locale = zhCn;
    onBeforeRouteUpdate(() => {
      window.scrollTo(0, 0);
      init(route);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(ElConfigProvider), {
        locale: _unref(locale)
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(route).meta.layout ? 'Auth' : 'Default')))]),
        _: 1
      }, 8, ["locale"]);
    };
  }
});